import request from "../utils/request";
//获取解锁组列表
export function getLockGroupList(params,number=1) {
    return request({
        url: `/lockGroup/list?queryType=${number}&pageNum=${params.pageNum?params.pageNum:''}&pageSize=${params.pageSize?params.pageSize:''}&groupName=${params.groupName?params.groupName:''}&lockGroupType=${params.lockGroupType?params.lockGroupType:''}`,
        method: "get"
    });
}

//获取解锁方式类型
export function getLockMode() {
    return request({
        url: `/lockGroup/listTypes`,
        method: "get"
    });
}

//根据id查询接口
export function getLockGroupById(params) {
    return request({
        url: `/lockGroup/getById?id=${params.id}`,
        method: "get",
    });
}

//新建解锁方式
export function lockGroupCreate(params) {
    return request({
        url: `/lockGroup/add`,
        method: "post",
        data: {
            lockGroupCO: params
        }
    });
}

//编辑解锁方式
export function lockGroupEdit(params) {
    return request({
        url: `/lockGroup/update`,
        method: "post",
        data: {
            lockGroupCO: params
        }
    });
}
//删除解锁组
export function deleteGroup(params) {
    return request({
        url: `/lockGroup/delete`,
        method: "post",
        data: {
            id: params.id
        }
    });
}
//获取所有的解锁列表
export function getAllLockType() {
    return request({
        url: `/lock/list?queryType=0`,
        method: "get",
     
    });
}